import { createRouter, createWebHistory } from 'vue-router'
import GalleryDetail from '@/views/gallery-detail.vue'
import IosAppDownload from '@/views/ios_app_download.vue'

const routes = [
  { path: '/gallery/detail/:id', name: 'content', component: GalleryDetail },
  { path: '/apps_download/ios', name: 'ios_app', component: IosAppDownload }
]

const router = createRouter({ history: createWebHistory(), routes })

export default router
